import { ITableHeader } from '../components/Table/types';
import { AUTOMATION_TEST_ID } from '../../../../constants/general';
import { ReactComponent as duplicateSVG } from '../../../../assets/svg/invoices-icons/icon-duplicate-action.svg';
import { ReactComponent as cancelSVG } from '../../../../assets/icons/svg/shared/ic-shared-trash.svg';
import { ReactComponent as previewSVG } from '../../../../assets/icons/svg/shared/ic-shared-eye-opened.svg';
import { ReactComponent as shareLinkSVG } from '../../../../assets/svg/invoices-icons/icon-share-link-action.svg';
import { ReactComponent as downloadSVG } from '../../../../assets/svg/invoices-icons/icon-download.svg';
import { ReactComponent as paymentAppMethodIcon } from '../../../../assets/svg/invoices-icons/icon-pm-payment-app.svg';
import { ReactComponent as cashMethodIcon } from '../../../../assets/svg/invoices-icons/icon-pm-cash.svg';
import { ReactComponent as checkMethodIcon } from '../../../../assets/svg/invoices-icons/icon-pm-check.svg';
import { ReactComponent as bankTransferMethodIcon } from '../../../../assets/svg/invoices-icons/icon-pm-bank-transfer.svg';
import { ReactComponent as paypalMethodIcon } from '../../../../assets/svg/invoices-icons/icon-pm-paypal.svg';
import { ReactComponent as cryptoMethodIcon } from '../../../../assets/svg/invoices-icons/icon-pm-crypto.svg';
import { ReactComponent as linkIcon } from '../../../../assets/svg/invoices-icons/icon-link.svg';
import { RoleType } from '../../../../types';

export const INVOICES_TABLE_COLUMNS: Array<ITableHeader> = [
  { title: 'INVOICES_TABLE.COLUMN_HEADER.INVOICE_AND_DATE', key: 'invoice' },
  { title: 'INVOICES_TABLE.COLUMN_HEADER.CLIENT', key: 'client' },
  { title: 'INVOICES_TABLE.COLUMN_HEADER.DUE_DATE', key: 'dueDate' },
  { title: 'INVOICES_TABLE.COLUMN_HEADER.STATUS', key: 'status' },
  { title: 'INVOICES_TABLE.COLUMN_HEADER.AMOUNT', key: 'amount' },
  { title: 'INVOICES_TABLE.COLUMN_HEADER.ACTION', key: 'action' },
];

export const INVOICE_HUB_TABLES = {
  OUTSTANDING: {
    title: 'INVOICES_TABLE.TITLES.UNPAID',
    name: 'outstanding',
  },
  PAID: {
    title: 'INVOICES_TABLE.TITLES.PAID',
    name: 'paid',
  },
  CANCELED: {
    title: 'INVOICES_TABLE.TITLES.CANCELED',
    name: 'canceled',
  },
} as const;

export const STATUS_BADGE_LABELS = {
  SENT: 'INVOICES_TABLE.STATUS_BADGES.SENT',
  PAID: 'INVOICES_TABLE.STATUS_BADGES.PAID',
  CREATED: 'INVOICES_TABLE.STATUS_BADGES.CREATED',
  CANCELED: 'INVOICES_TABLE.STATUS_BADGES.CANCELED',
};

export const INVOICE_STATUS_GROUP_MAPPING = {
  SENT: ['SENT', 'PAYMENT_PENDING', 'PAYMENT_DECLINED'],
  UNSENT: ['OUTSTANDING'],
  PAID: ['PAID'],
  CANCELED: ['CANCEL'],
};

export const INVOICE_STATUSES = {
  SENT: 'SENT',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PAYMENT_DECLINED: 'PAYMENT_DECLINED',
  OUTSTANDING: 'OUTSTANDING',
  PAID: 'PAID',
  CANCEL: 'CANCEL',
};

export const RECORD_CNT = 50;

const AUTOMATION_ID_APP_NAME = 'invoice-hub';

export const INVOICE_HUB_AUTOMATION_IDS = {
  HUB_TITLE: `${AUTOMATION_TEST_ID}__${AUTOMATION_ID_APP_NAME}__title`,
  HUB_SUBTITLE: `${AUTOMATION_TEST_ID}__${AUTOMATION_ID_APP_NAME}__subtitle`,
  HUB_TAB_UNPAID: `${AUTOMATION_TEST_ID}__${AUTOMATION_ID_APP_NAME}__tab-unpaid`,
  HUB_TAB_HISTORY: `${AUTOMATION_TEST_ID}__${AUTOMATION_ID_APP_NAME}__tab-history`,
  HUB_TABLE_OUTSTANDING: `${AUTOMATION_TEST_ID}__${AUTOMATION_ID_APP_NAME}__table-outstanding`,
  HUB_TABLE_PAID: `${AUTOMATION_TEST_ID}__${AUTOMATION_ID_APP_NAME}__table-paid`,
  HUB_TABLE_CANCELED: `${AUTOMATION_TEST_ID}__${AUTOMATION_ID_APP_NAME}__table-canceled`,
  HUB_TABLE_EMPTY_STATE_OUTSTANDING: `${AUTOMATION_TEST_ID}__${AUTOMATION_ID_APP_NAME}__empty-state-outstanding`,
  HUB_TABLE_EMPTY_STATE_PAID: `${AUTOMATION_TEST_ID}__${AUTOMATION_ID_APP_NAME}__empty-state-paid`,
  HUB_TABLE_EMPTY_STATE_CANCELED: `${AUTOMATION_TEST_ID}__${AUTOMATION_ID_APP_NAME}__empty-state-canceled`,
};

export const INVOICE_ACTIONS = {
  PREVIEW: 'PREVIEW',
  DUPLICATE: 'DUPLICATE',
  SHARE_LINK: 'SHARE_LINK',
  DOWNLOAD_PRINT_PDF: 'DOWNLOAD_PRINT_PDF',
  CANCEL: 'CANCEL',
  SEND_AGAIN: 'SEND_AGAIN',
  MARK_AS_PAID: 'MARK_AS_PAID',
  MARK_AS_UNPAID: 'MARK_AS_UNPAID',
  SHARE_INVOICE: 'SHARE_INVOICE',
};

const INVOICE_ACTIONS_TEXTS = {
  SEND_AGAIN: 'INVOICE_HUB.INVOICE_PAGE.ACTION.SEND_AGAIN',
  DUPLICATE: 'INVOICE_HUB.INVOICE_PAGE.ACTION.DUPLICATE',
  SHARE_LINK: 'INVOICE_HUB.INVOICE_PAGE.ACTION.SHARE_LINK',
  CANCEL: 'INVOICE_HUB.INVOICE_PAGE.ACTION.CANCEL',
  MARK_AS_PAID: 'INVOICE_HUB.INVOICE_PAGE.ACTION.MARK_AS_PAID',
  MARK_AS_UNPAID: 'INVOICE_HUB.INVOICE_PAGE.ACTION.MARK_AS_UNPAID',
  SEND_VIA_EMAIL: 'INVOICE_HUB.INVOICE_PAGE.ACTION.SEND_VIA_EMAIL',
  SHARE_INVOICE: 'INVOICE_HUB.INVOICE_PAGE.ACTION.SHARE_INVOICE',
};

export const PRIMARY_ACTIONS_MAPPING = {
  SENT: [
    {
      name: INVOICE_ACTIONS.MARK_AS_PAID, title: INVOICE_ACTIONS_TEXTS.MARK_AS_PAID, SVGIcon: null, width: '', key: 'button_mark_as_paid',
    }],
  UNSENT: [
    /* {
      name: INVOICE_ACTIONS.SEND_AGAIN, title: INVOICE_ACTIONS_TEXTS.SEND_VIA_EMAIL, SVGIcon: sendAgainSVG, width: 'w-[207px]', key: 'button_send_via_email',
    }, */
    {
      name: INVOICE_ACTIONS.SHARE_INVOICE,
      title: INVOICE_ACTIONS_TEXTS.SHARE_INVOICE,
      SVGIcon: linkIcon,
      width: 'w-[210px]',
      key: 'button_share_invoice',
    },
    {
      name: INVOICE_ACTIONS.MARK_AS_PAID, title: INVOICE_ACTIONS_TEXTS.MARK_AS_PAID, SVGIcon: null, width: '', key: 'button_mark_as_paid',
    }],
  PAID: [
    /* {
        name: INVOICE_ACTIONS.DUPLICATE, title: INVOICE_ACTIONS_TEXTS.DUPLICATE, SVGIcon: duplicateSVG, width: 'w-[168px]', key: 'button_duplicate',
      }, */
    {
      name: INVOICE_ACTIONS.MARK_AS_UNPAID, title: INVOICE_ACTIONS_TEXTS.MARK_AS_UNPAID, SVGIcon: null, width: '', key: 'button_mark_as_unpaid',
    }],
  CANCELED: [],
};
/*
const SECONDARY_ACTION_SEND_AGAIN = {
  name: INVOICE_ACTIONS.SEND_AGAIN,
  title: INVOICE_ACTIONS_TEXTS.SEND_AGAIN,
  SVGIcon: sendAgainSVG,
  key: 'button_send_again',
};
*/
/*
const SECONDARY_ACTION_DUPLICATE = {
  name: INVOICE_ACTIONS.DUPLICATE,
  title: INVOICE_ACTIONS_TEXTS.DUPLICATE,
  SVGIcon: duplicateSVG,
  key: 'button_duplicate',
};
*/
const SECONDARY_ACTION_SHARE_LINK = {
  name: INVOICE_ACTIONS.SHARE_LINK,
  title: INVOICE_ACTIONS_TEXTS.SHARE_LINK,
  SVGIcon: shareLinkSVG,
  key: 'button_share_link',
};
const SECONDARY_ACTION_CANCEL = {
  name: INVOICE_ACTIONS.CANCEL,
  title: INVOICE_ACTIONS_TEXTS.CANCEL,
  SVGIcon: cancelSVG,
  key: 'button_cancel',
};

export const SECONDARY_ACTIONS_MAPPING = {
  SENT: [SECONDARY_ACTION_SHARE_LINK, SECONDARY_ACTION_CANCEL],
  UNSENT: [SECONDARY_ACTION_SHARE_LINK, SECONDARY_ACTION_CANCEL],
  PAID: [SECONDARY_ACTION_SHARE_LINK, SECONDARY_ACTION_CANCEL],
  CANCELED: [SECONDARY_ACTION_SHARE_LINK],
};

type paymentMethodOptions = {
  [key: string]: string;
};
export const PM_2DISPLAY_MAPPING: paymentMethodOptions = {
  PAYMENT_APP: 'PAYMENT_METHODS.PAYMENT_APP',
  CASH: 'PAYMENT_METHODS.CASH',
  CHECK_DEPOSIT: 'PAYMENT_METHODS.CHECK',
  ACH: 'PAYMENT_METHODS.ACH',
  ONLINE_PLATFORM: 'PAYMENT_METHODS.ONLINE_PLATFORM',
  OTHER: 'PAYMENT_METHODS.OTHER',
} as const;

const mapMenuTitleToIcon = {
  [INVOICE_ACTIONS.PREVIEW]: previewSVG,
  [INVOICE_ACTIONS.DUPLICATE]: duplicateSVG,
  [INVOICE_ACTIONS.SHARE_LINK]: shareLinkSVG,
  [INVOICE_ACTIONS.DOWNLOAD_PRINT_PDF]: downloadSVG,
  [INVOICE_ACTIONS.CANCEL]: cancelSVG,
};

export const DEFAULT_INVOICE_MENU_ACTIONS = [
  {
    title: 'INVOICE_HUB.INVOICE_ACTIONS_MENU.PREVIEW',
    SVGComponent: mapMenuTitleToIcon[INVOICE_ACTIONS.PREVIEW],
    SVGColor: 'stroke-bw08',
    name: INVOICE_ACTIONS.PREVIEW,
    testId: 'previewAction',
  },
  {
    title: '',
    SVGComponent: '',
    name: '',
    testId: 'subItemSplitter',
  },
  {
    title: 'INVOICE_HUB.INVOICE_ACTIONS_MENU.SHARE_LINK',
    SVGComponent: mapMenuTitleToIcon[INVOICE_ACTIONS.SHARE_LINK],
    SVGColor: 'stroke-bw08',
    name: INVOICE_ACTIONS.SHARE_LINK,
    testId: 'shareLinkAction',
  },
  {
    title: 'INVOICE_HUB.INVOICE_ACTIONS_MENU.DOWNLOAD_PRINT_PDF',
    SVGComponent: mapMenuTitleToIcon[INVOICE_ACTIONS.DOWNLOAD_PRINT_PDF],
    SVGColor: 'stroke-bw08',
    name: INVOICE_ACTIONS.DOWNLOAD_PRINT_PDF,
    testId: 'downloadPDFAction',
  },
  {
    title: '',
    SVGComponent: '',
    name: '',
    testId: 'subItemSplitter',
  },
  {
    title: 'INVOICE_HUB.INVOICE_ACTIONS_MENU.CANCEL',
    SVGComponent: mapMenuTitleToIcon[INVOICE_ACTIONS.CANCEL],
    name: INVOICE_ACTIONS.CANCEL,
    textColor: 'text-red02',
    SVGColor: 'stroke-red02',
    arrowColor: 'text-red02',
    testId: 'cancelInvoiceAction',
    disableForRoles: [RoleType.ACCOUNTANT],
  },
];
export const CANCELED_INVOICE_MENU_ACTIONS = [
  {
    title: 'INVOICE_HUB.INVOICE_ACTIONS_MENU.PREVIEW',
    SVGComponent: mapMenuTitleToIcon[INVOICE_ACTIONS.PREVIEW],
    SVGColor: 'stroke-bw08',
    name: INVOICE_ACTIONS.PREVIEW,
    testId: 'previewAction',
  },
  {
    title: 'INVOICE_HUB.INVOICE_ACTIONS_MENU.SHARE_LINK',
    SVGComponent: mapMenuTitleToIcon[INVOICE_ACTIONS.SHARE_LINK],
    SVGColor: 'stroke-bw08',
    name: INVOICE_ACTIONS.SHARE_LINK,
    testId: 'shareLinkAction',
  },
];

type invoicesPaymentMethodOptions = {
  [key: string]: string;
};
export const API_INVOICES_PAYMENT_METHODS: invoicesPaymentMethodOptions = {
  PAYMENT_APP: 'PAYMENT_APP',
  CASH: 'CASH',
  CHECK: 'CHECK_DEPOSIT',
  BANK_TRANSFER: 'ACH',
  PAYPAL: 'ONLINE_PLATFORM',
  OTHER: 'OTHER',
};

export const PAYMENT_METHODS_DROPDOWN_OPTIONS = [
  {
    value: API_INVOICES_PAYMENT_METHODS.PAYMENT_APP,
    icon: paymentAppMethodIcon,
    text: 'PAYMENT_METHODS.PAYMENT_APP',
  },
  {
    value: API_INVOICES_PAYMENT_METHODS.CASH,
    icon: cashMethodIcon,
    text: 'PAYMENT_METHODS.CASH',
  },
  {
    value: API_INVOICES_PAYMENT_METHODS.CHECK,
    icon: checkMethodIcon,
    text: 'PAYMENT_METHODS.CHECK',
  },
  {
    value: API_INVOICES_PAYMENT_METHODS.BANK_TRANSFER,
    icon: bankTransferMethodIcon,
    text: 'PAYMENT_METHODS.ACH',
  },
  {
    value: API_INVOICES_PAYMENT_METHODS.PAYPAL,
    icon: paypalMethodIcon,
    text: 'PAYMENT_METHODS.PAYPAL',
  },
  {
    value: API_INVOICES_PAYMENT_METHODS.OTHER,
    icon: cryptoMethodIcon,
    text: 'PAYMENT_METHODS.OTHER',
  },
];

export const STATUS_QUERY_STRING = {
  OUTSTANDING: 'status=OUTSTANDING&status=SENT&status=PAYMENT_PENDING&status=PAYMENT_DECLINED',
  PAID: 'status=PAID',
  CANCELED: 'status=CANCEL',
};
export const ORDER_BY_QUERY_STRING = {
  OUTSTANDING: 'sort=DUEDATE',
  PAID: 'sort=PAID_CANCEL_TIME',
  CANCELED: 'sort=PAID_CANCEL_TIME',
};

export const INVOICES_DISCOUNT_TYPES = {
  FIXED: 'FIXED',
  PERCENT: 'PERCENT',
};
